import { ComputedRef } from 'vue'

import { Course } from '@/domain/entities/problem/course'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { CourseViewModel } from '@/presentation/viewmodels/problem/courseViewModel'

export class CoursePresenter {
  private viewModel: CourseViewModel

  constructor(viewModel: CourseViewModel) {
    this.viewModel = viewModel
  }

  get courseList(): ComputedRef<{ [id: number]: Course }> {
    return this.viewModel.courseList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getCourseList(displayLanguage: DisplayLanguageType): Promise<void> {
    await this.viewModel.getCourseList(displayLanguage)
  }

  async getCourseById(displayLanguage: DisplayLanguageType, courseId: number): Promise<void> {
    await this.viewModel.getCourseById(displayLanguage, courseId)
  }
}
